import { StorePickerFilters } from "./components/filters/storePickerFilters.container";
import { StorePickerFooterComponent } from "./components/footer/storePickerFooter.component";
import { StorePickerInput } from "./components/input/storePickerInput.container";
import { StorePickerStores } from "./components/stores/storePickerStores.container";

import "./storePicker.scss";

const StorePickerComponent = () => {
    return (
        <section className={"store-picker"}>
            <div className={"store-picker__controls"}>
                <StorePickerInput />
                <StorePickerFilters />
            </div>
            <StorePickerStores />
            <StorePickerFooterComponent />
        </section>
    );
};

export { StorePickerComponent };
